import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Sidebar } from "../Sidebar";
import { Header } from "../Header";
import Banner from "../components/Banner";
import SliderContainer from "../components/SliderContainer";
import { Footer } from "../Footer";

const RedTiger = () => {
  const [isSidebar, setSidebar] = useState(false);
  const PopularGames = [
    {
      src: "/RedTiger_games/wings_of_ra.png",
      name: "wings of ra",
      tableCode: "rts_wira",
      tpGameId: 603,
      provider: "vking",
      endpoint: "redtiger-games",
    },

    {
      angularCasinoGameId: 1347,
      name: "Wild Hog Luau",
      src: "https://cdn.cloudd.site/vking/lobby/20230624059198.webp",
      isActive: true,
      isShow: true,
      types: 1009,
      isNewGame: false,
      tableCode: "RTG-wildhogluau",
      apiParamName: "appIsVkingPlayLogin",
      endpoint: "redtiger-games",
      categoryID: 6,
      displayOrder: 803,
      appCasinoGameID: 1,
      appProviderID: 22,
      gameType: "Slots",
      provider: "vking",
      tpGameId: 1009,
      isPopular: false,
      isShowOnDashboard: false,
      appTpGameRefType: 400,
      displayOrderNew: null,
      displayOrderPopular: null,
      displayOrderLive: null,
      displayOrderVirtual: null,
    },
    {
      angularCasinoGameId: 1348,
      name: "Warrior Conquest",
      src: "https://cdn.cloudd.site/vking/lobby/20230620437007.webp",
      isActive: true,
      isShow: true,
      types: 1009,
      isNewGame: false,
      tableCode: "RTG-warriorconquest",
      apiParamName: "appIsVkingPlayLogin",
      endpoint: "redtiger-games",
      categoryID: 6,
      displayOrder: 804,
      appCasinoGameID: 1,
      appProviderID: 22,
      gameType: "Slots",
      provider: "vking",
      tpGameId: 1009,
      isPopular: false,
      isShowOnDashboard: false,
      appTpGameRefType: 400,
      displayOrderNew: null,
      displayOrderPopular: null,
      displayOrderLive: null,
      displayOrderVirtual: null,
    },
    {
      angularCasinoGameId: 1349,
      name: "Triple Twister",
      src: "https://cdn.cloudd.site/vking/lobby/20230940239318.webp",
      isActive: true,
      isShow: true,
      types: 1009,
      isNewGame: false,
      tableCode: "RTG-tripletwister",
      apiParamName: "appIsVkingPlayLogin",
      endpoint: "redtiger-games",
      categoryID: 6,
      displayOrder: 805,
      appCasinoGameID: 1,
      appProviderID: 22,
      gameType: "Slots",
      provider: "vking",
      tpGameId: 1009,
      isPopular: false,
      isShowOnDashboard: false,
      appTpGameRefType: 400,
      displayOrderNew: null,
      displayOrderPopular: null,
      displayOrderLive: null,
      displayOrderVirtual: null,
    },
    {
      angularCasinoGameId: 1350,
      name: "Triple Tigers",
      src: "https://cdn.cloudd.site/vking/lobby/20230938267183.webp",
      isActive: true,
      isShow: true,
      types: 1009,
      isNewGame: false,
      tableCode: "RTG-tripletigers",
      apiParamName: "appIsVkingPlayLogin",
      endpoint: "redtiger-games",
      categoryID: 6,
      displayOrder: 806,
      appCasinoGameID: 1,
      appProviderID: 22,
      gameType: "Slots",
      provider: "vking",
      tpGameId: 1009,
      isPopular: false,
      isShowOnDashboard: false,
      appTpGameRefType: 400,
      displayOrderNew: null,
      displayOrderPopular: null,
      displayOrderLive: null,
      displayOrderVirtual: null,
    },
    {
      angularCasinoGameId: 1351,
      name: "Trigger Happy",
      src: "https://cdn.cloudd.site/vking/lobby/20230937434508.webp",
      isActive: true,
      isShow: true,
      types: 1009,
      isNewGame: false,
      tableCode: "RTG-triggerhappy",
      apiParamName: "appIsVkingPlayLogin",
      endpoint: "redtiger-games",
      categoryID: 6,
      displayOrder: 807,
      appCasinoGameID: 1,
      appProviderID: 22,
      gameType: "Slots",
      provider: "vking",
      tpGameId: 1009,
      isPopular: false,
      isShowOnDashboard: false,
      appTpGameRefType: 400,
      displayOrderNew: null,
      displayOrderPopular: null,
      displayOrderLive: null,
      displayOrderVirtual: null,
    },
    {
      angularCasinoGameId: 1352,
      name: "Toltec Gems",
      src: "https://cdn.cloudd.site/vking/lobby/20230937063458.webp",
      isActive: true,
      isShow: true,
      types: 1009,
      isNewGame: false,
      tableCode: "RTG-toltecgems",
      apiParamName: "appIsVkingPlayLogin",
      endpoint: "redtiger-games",
      categoryID: 6,
      displayOrder: 808,
      appCasinoGameID: 1,
      appProviderID: 22,
      gameType: "Slots",
      provider: "vking",
      tpGameId: 1009,
      isPopular: false,
      isShowOnDashboard: false,
      appTpGameRefType: 400,
      displayOrderNew: null,
      displayOrderPopular: null,
      displayOrderLive: null,
      displayOrderVirtual: null,
    },
    {
      angularCasinoGameId: 1353,
      name: "Three Kingdom Wars",
      src: "https://cdn.cloudd.site/vking/lobby/20230936214674.webp",
      isActive: true,
      isShow: true,
      types: 1009,
      isNewGame: false,
      tableCode: "RTG-threekingdomwars ",
      apiParamName: "appIsVkingPlayLogin",
      endpoint: "redtiger-games",
      categoryID: 6,
      displayOrder: 809,
      appCasinoGameID: 1,
      appProviderID: 22,
      gameType: "Slots",
      provider: "vking",
      tpGameId: 1009,
      isPopular: false,
      isShowOnDashboard: false,
      appTpGameRefType: 400,
      displayOrderNew: null,
      displayOrderPopular: null,
      displayOrderLive: null,
      displayOrderVirtual: null,
    },

    {
      angularCasinoGameId: 1354,
      name: "The Big Bopper®",
      src: "https://cdn.cloudd.site/vking/lobby/20230934471204.webp",
      isActive: true,
      isShow: true,
      types: 1009,
      isNewGame: false,
      tableCode: "RTG-thebigbopper",
      apiParamName: "appIsVkingPlayLogin",
      endpoint: "redtiger-games",
      categoryID: 6,
      displayOrder: 810,
      appCasinoGameID: 1,
      appProviderID: 22,
      gameType: "Slots",
      provider: "vking",
      tpGameId: 1009,
      isPopular: false,
      isShowOnDashboard: false,
      appTpGameRefType: 400,
      displayOrderNew: null,
      displayOrderPopular: null,
      displayOrderLive: null,
      displayOrderVirtual: null,
    },
  
    {
      angularCasinoGameId: 1355,
      name: "Thai Emerald",
      src: "https://cdn.cloudd.site/vking/lobby/20230633151092.webp",
      isActive: true,
      isShow: true,
      types: 1009,
      isNewGame: false,
      tableCode: "RTG-thaiemerald",
      apiParamName: "appIsVkingPlayLogin",
      endpoint: "redtiger-games",
      categoryID: 6,
      displayOrder: 811,
      appCasinoGameID: 1,
      appProviderID: 22,
      gameType: "Slots",
      provider: "vking",
      tpGameId: 1009,
      isPopular: false,
      isShowOnDashboard: false,
      appTpGameRefType: 400,
      displayOrderNew: null,
      displayOrderPopular: null,
      displayOrderLive: null,
      displayOrderVirtual: null,
    },
    {
      angularCasinoGameId: 1356,
      name: "Texan Tycoon",
      src: "https://cdn.cloudd.site/vking/lobby/20230934058592.webp",
      isActive: true,
      isShow: true,
      types: 1009,
      isNewGame: false,
      tableCode: "RTG-texantycoon",
      apiParamName: "appIsVkingPlayLogin",
      endpoint: "redtiger-games",
      categoryID: 6,
      displayOrder: 812,
      appCasinoGameID: 1,
      appProviderID: 22,
      gameType: "Slots",
      provider: "vking",
      tpGameId: 1009,
      isPopular: false,
      isShowOnDashboard: false,
      appTpGameRefType: 400,
      displayOrderNew: null,
      displayOrderPopular: null,
      displayOrderLive: null,
      displayOrderVirtual: null,
    },
    {
      angularCasinoGameId: 1357,
      name: "T-REX 2",
      src: "https://cdn.cloudd.site/vking/lobby/20230941046328.webp",
      isActive: true,
      isShow: true,
      types: 1009,
      isNewGame: false,
      tableCode: "RTG-trex2",
      apiParamName: "appIsVkingPlayLogin",
      endpoint: "redtiger-games",
      categoryID: 6,
      displayOrder: 813,
      appCasinoGameID: 1,
      appProviderID: 22,
      gameType: "Slots",
      provider: "vking",
      tpGameId: 1009,
      isPopular: false,
      isShowOnDashboard: false,
      appTpGameRefType: 400,
      displayOrderNew: null,
      displayOrderPopular: null,
      displayOrderLive: null,
      displayOrderVirtual: null,
    },
   
    {
      angularCasinoGameId: 1358,
      name: "Sword of the Elements",
      src: "https://cdn.cloudd.site/vking/lobby/20230933207202.webp",
      isActive: true,
      isShow: true,
      types: 1009,
      isNewGame: false,
      tableCode: "RTG-swordoftheelements",
      apiParamName: "appIsVkingPlayLogin",
      endpoint: "redtiger-games",
      categoryID: 6,
      displayOrder: 814,
      appCasinoGameID: 1,
      appProviderID: 22,
      gameType: "Slots",
      provider: "vking",
      tpGameId: 1009,
      isPopular: false,
      isShowOnDashboard: false,
      appTpGameRefType: 400,
      displayOrderNew: null,
      displayOrderPopular: null,
      displayOrderLive: null,
      displayOrderVirtual: null,
    },

    {
      angularCasinoGameId: 1359,
      name: "Sweet Shop Collect",
      src: "https://cdn.cloudd.site/vking/lobby/20231054302092.webp",
      isActive: true,
      isShow: true,
      types: 1009,
      isNewGame: false,
      tableCode: "RTG-sweetshopcollect",
      apiParamName: "appIsVkingPlayLogin",
      endpoint: "redtiger-games",
      categoryID: 6,
      displayOrder: 815,
      appCasinoGameID: 1,
      appProviderID: 22,
      gameType: "Slots",
      provider: "vking",
      tpGameId: 1009,
      isPopular: false,
      isShowOnDashboard: false,
      appTpGameRefType: 400,
      displayOrderNew: null,
      displayOrderPopular: null,
      displayOrderLive: null,
      displayOrderVirtual: null,
    },
    {
      angularCasinoGameId: 1360,
      name: "Sweet 16 Blast!",
      src: "https://cdn.cloudd.site/vking/lobby/20230631117772.webp",
      isActive: true,
      isShow: true,
      types: 1009,
      isNewGame: false,
      tableCode: "RTG-sweet16blast",
      apiParamName: "appIsVkingPlayLogin",
      endpoint: "redtiger-games",
      categoryID: 6,
      displayOrder: 816,
      appCasinoGameID: 1,
      appProviderID: 22,
      gameType: "Slots",
      provider: "vking",
      tpGameId: 1009,
      isPopular: false,
      isShowOnDashboard: false,
      appTpGameRefType: 400,
      displayOrderNew: null,
      displayOrderPopular: null,
      displayOrderLive: null,
      displayOrderVirtual: null,
    },
    {
      angularCasinoGameId: 1361,
      name: "Sweet 16",
      src: "https://cdn.cloudd.site/vking/lobby/20230932086541.webp",
      isActive: true,
      isShow: true,
      types: 1009,
      isNewGame: false,
      tableCode: "RTG-sweet16",
      apiParamName: "appIsVkingPlayLogin",
      endpoint: "redtiger-games",
      categoryID: 6,
      displayOrder: 817,
      appCasinoGameID: 1,
      appProviderID: 22,
      gameType: "Slots",
      provider: "vking",
      tpGameId: 1009,
      isPopular: false,
      isShowOnDashboard: false,
      appTpGameRefType: 400,
      displayOrderNew: null,
      displayOrderPopular: null,
      displayOrderLive: null,
      displayOrderVirtual: null,
    },
  ];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setSidebar(true);
      } else {
        setSidebar(false);
      }
    };

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Initial check to set the correct sidebar state
    handleResize();

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container">
            <div _ngcontent-jrx-c95="" className="body-container">
              <Sidebar isSidebar={isSidebar} />
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />

                <Banner />

                <div className="mt-5 mb-5 newMain">
                  <p className="d-flex justify-content-between align-items-center main mx-3">
                    <span className="head">RedTiger Games</span>{" "}
                    <span className="all">See All</span>
                  </p>

                  <div className="brdr text-nowrap">
                    <SliderContainer CurrentSlider={PopularGames} />
                  </div>
                </div>
                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>
      </div>
    </app-root>
  );
};

export default RedTiger;
